const ratio = ({ width, height }: { width: number; height: number }) => width / height;

export default ratio;
